import { useRef, useState } from 'react'
import { Text, Box } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'

export function ContactSign(props) {
  const meshRef = useRef()
  const [hovered, setHovered] = useState(false)
  
  useFrame((state) => {
    if (meshRef.current) {
      meshRef.current.rotation.y = Math.sin(state.clock.elapsedTime) * 0.1
      meshRef.current.position.y = props.position[1] + Math.sin(state.clock.elapsedTime * 2) * 0.0
    }
  })
  
  const handleClick = (e) => {
    e.stopPropagation()
    // Create a temporary anchor element and click it
    const link = document.createElement('a')
    link.href = "mailto:coffeecoded@gmail.com?subject=Let's build a new project!"
    link.click()
  }
  
  return (
    <group 
      ref={meshRef} 
      {...props}
      onClick={handleClick}
      onPointerOver={() => {
        setHovered(true)
        document.body.style.cursor = 'pointer'
      }}
      onPointerOut={() => {
        setHovered(false)
        document.body.style.cursor = 'auto'
      }}
    >
      {/* Background box with color inversion on hover */}
      <Box args={[2, 1.3, 0.1]}>
        <meshStandardMaterial 
          color={hovered ? "black" : "#35c19f"}
          emissive={hovered ? "black" : "#35c19f"}
          emissiveIntensity={hovered ? 0 : 0.5}  // No emission when black
          toneMapped={false}
          roughness={0.2}
          metalness={0.3}
        />
      </Box>
      
      {/* Contact text - inverts with background */}
      <Text
        font="/Gohu/GohuFont14NerdFontMono-Regular.ttf"
        fontSize={0.3}
        color={hovered ? "#35c19f" : "black"}
        anchorX="center"
        anchorY="middle"
        position={[0, 0, 0.06]}
      >
        {`\uF095`} CONTACT
      </Text>
    </group>
  )
}